/**
 * @file Button displayed on onboarding or purchase headers for contacting support.
 */

import React from 'react';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
import { useQuery } from 'react-apollo';

import { SUPPORT_MODAL } from '../../constants/modals';
import HelpBubblesIcon from '../icons/HelpBubblesIcon';
import Button from '../global/Button';
import { MeQuery } from '../../graphql/queries/account';
import { isShutterbug } from '../../util/account';
import { CONSUMER_FEEDBACK_MODAL } from '../global/ConsumerFeedbackModal';

const propTypes = {
  openModal: PropTypes.func.isRequired,
  className: PropTypes.string,
  iconColor: PropTypes.string,
  iconSize: PropTypes.string,
};

const MobileHeaderSupportButton = ({
  openModal,
  className,
  iconColor = '#97caff',
  iconSize = '24',
  ...props
}) => {
  const authenticated = useSelector(({ auth }) => auth.authenticated);
  const { data: { me: user } = {} } = useQuery(MeQuery, {
    skip: !authenticated,
  });

  if (!authenticated || !user) {
    return null; // modal does not work with unauthed users.
  }

  return (
    <Button
      className={`lh-0 ${className || ''}`}
      btnStyle="reset"
      onClick={() => {
        if (!isShutterbug(user)) {
          openModal(SUPPORT_MODAL);
        } else {
          openModal(CONSUMER_FEEDBACK_MODAL);
        }
      }}
      {...props}
    >
      <HelpBubblesIcon color={iconColor} size={iconSize} />
    </Button>
  );
};

MobileHeaderSupportButton.propTypes = propTypes;

export default MobileHeaderSupportButton;
